import { render, staticRenderFns } from "./adminRegistration.vue?vue&type=template&id=2f13e5c8&scoped=true&"
import script from "./adminRegistration.vue?vue&type=script&lang=js&"
export * from "./adminRegistration.vue?vue&type=script&lang=js&"
import style0 from "./adminRegistration.vue?vue&type=style&index=0&id=2f13e5c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13e5c8",
  null
  
)

export default component.exports